export default __webpack_public_path__ + "static/media/SmartVote.50e1aa04.jpeg";